import { getClassroomApiUrl } from "js/utils/getBackendUrl";
import * as clsApi from "./classroomApi";

export async function getLicensedFeatures(): Promise<Response> {
	const device = clsApi.authHeaders().Device;
	const classroomApiUrl = getClassroomApiUrl(window.location.hostname);
	return fetch(`${classroomApiUrl}/teacher-portal/config/v1/appliances/${device}/classwize/licensed-features`, {
		method: "GET",
		headers: clsApi.authHeaders(),
	});
}

export enum LicensedFeatures {
	ClassroomManagement = "CLASSROOM_MANAGEMENT",
	Courses = "COURSES",
	HallPass = "HALL_PASS",
}

export type LicensedFeaturesResponse = {
	appliance: string;
	features: LicensedFeatures[];
};
